const routes = [
  {
    path: '/workshopAproval',
    name: 'workshopAproval',
    component: () => import('./pages/workshopAproval'),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  }
]
export default routes